module.exports = __webpack_public_path__ + "img/gzdp.9d9c6f14.jpg";